import styled from '@emotion/styled'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'

import { keyframes } from '@emotion/react'
import tokens from '../../design/design-tokens/tokens'
import {
  BUTTON_VARIANT_DANGER,
  BUTTON_VARIANT_NEGATIVE,
  BUTTON_VARIANT_NEUTRAL,
  BUTTON_VARIANT_PRIMARY,
  BUTTON_VARIANT_SECONDARY,
  Button
} from '../Button'
import { Icon } from '../icons'

const tokensVariant = variant => {
  switch (variant) {
    case BUTTON_VARIANT_PRIMARY:
      return BUTTON_VARIANT_PRIMARY
    case BUTTON_VARIANT_SECONDARY:
      return BUTTON_VARIANT_SECONDARY
    case BUTTON_VARIANT_NEUTRAL:
      return BUTTON_VARIANT_NEUTRAL
    case BUTTON_VARIANT_DANGER:
      return BUTTON_VARIANT_DANGER
    case BUTTON_VARIANT_NEGATIVE:
      return BUTTON_VARIANT_NEGATIVE
    default:
      return BUTTON_VARIANT_PRIMARY
  }
}
const rotateTo45 = keyframes`
  0%   { transform: rotate(0deg); }
  100% { transform: rotate(45deg); }
  `

const rotateTo0 = keyframes`
  0%   { transform: rotate(45deg); }
  100% { transform: rotate(0deg); }
  `

const StyledButton = styled(Button)`
  position: relative;
  span {
    display: flex;
    flex-direction: row !important;
    align-items: center;
  }
`

const StyledIconContainer = styled.div`
  padding-left: 16px;
`

const StyledBorder = styled.div`
  position: absolute;
  border-left: 1px solid grey;
  border-color: ${({ kind }) => tokens.Button[tokensVariant(kind)].borderColor};
  bottom: 0;
  top: 0;
  right: 44px;
`

const StyledIconOpen = styled(Icon)`
  display: block;
  animation-direction: forward;
  animation: ${rotateTo45} ${({ animation }) => (animation ? 250 : 0)}ms 0s
    linear forwards;
`

const StyledIconClose = styled(Icon)`
  display: block;
  animation-direction: forward;
  animation: ${rotateTo0} ${({ animation }) => (animation ? 250 : 0)}ms 0s
    linear forwards;
`

const StyledTextContainer = styled.div`
  padding-right: 16px;
`

export const ButtonMore = ({
  text,
  callback,
  opened,
  kind,
  className,
  'data-mu-test': dataAttributeTest
}) => {
  const [open, setOpen] = useState(opened)
  const [animation, setAnimation] = useState('')

  useEffect(() => {
    setOpen(opened)
  }, [opened])

  const handleCallback = e => {
    const currentState = !open
    setOpen(currentState)
    // esegue l'animazione solo dopo il primo click
    setAnimation('active')
    callback(e, currentState)
  }

  return (
    <StyledButton
      kind={kind}
      onClick={handleCallback}
      className={classnames('buttonmore', className)}
      data-mu-test={classnames('buttonmore', dataAttributeTest)}
    >
      <StyledTextContainer>{text}</StyledTextContainer>
      <StyledBorder kind={kind}> </StyledBorder>
      <StyledIconContainer>
        {open && (
          <StyledIconOpen icon='plus' family='sli' animation={animation} />
        )}
        {!open && (
          <StyledIconClose icon='plus' family='sli' animation={animation} />
        )}
      </StyledIconContainer>
    </StyledButton>
  )
}

ButtonMore.defaultProps = {
  text: '',
  callback: () => {},
  opened: true,
  kind: BUTTON_VARIANT_SECONDARY
}

ButtonMore.propTypes = {
  text: PropTypes.string,
  callback: PropTypes.func,
  opened: PropTypes.bool,
  className: PropTypes.string,
  kind: PropTypes.oneOf([
    BUTTON_VARIANT_PRIMARY,
    BUTTON_VARIANT_SECONDARY,
    BUTTON_VARIANT_NEUTRAL,
    BUTTON_VARIANT_DANGER,
    BUTTON_VARIANT_NEGATIVE
  ]),
  /**
   * Additional values for data-attribute used for tests and tracking
   **/
  'data-mu-test': PropTypes.string
}
